import { Head } from '@inertiajs/react'
import { HomeMark } from '../../shared/HomeMark.jsx'
import { withSiteFooter } from '../../shared/SiteFooter.jsx'
import { Button } from '../../components/core/Button.jsx'

// GET /verify/:token with an unreadable token — served as a 404. One state for
// expired, tampered with, or killed by an address change. Which one happened is
// information about an account that may not belong to whoever holds the link,
// so the page names none of them.

export default function VerifyExpired() {
  return (
    <>
      <Head title="This link is no longer valid" />
      <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-8 px-6 py-16">
        <HomeMark />
        <div className="flex flex-col gap-2">
          <h1 className="page-title">This link is no longer valid</h1>
          <p className="text-[15px] text-[color:var(--text-body)]">
            Confirmation links are valid for two days. Sign in and we will send you a new one.
          </p>
        </div>
        <Button variant="primary" size="lg" block href="/session/new">
          Sign in
        </Button>
      </main>
    </>
  )
}

VerifyExpired.layout = withSiteFooter
